import styled from 'styled-components';

export const SliderWrapper = styled.div`
  .slick-slider {
    .slick-list {
      padding-bottom: 65px;

      @media (max-width: 768px) {
        padding-bottom: 35px;
      }
    }

    .arrow {
      position: absolute;
      bottom: 10px;
      width: 40px;
      height: 40px;
      z-index: 11;
      cursor: pointer;

      &.next {
        right: 46%;

        @media (max-width: 768px) {
          right: 36%;
        }
      }

      &.prev {
        left: 46%;

        @media (max-width: 768px) {
          left: 36%;
        }
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .slick-dots li.slick-active button:before {
      opacity: 1;
      color: var(--primary-color);
    }

    .slick-dots li button:before {
      font-size: 10px;
    }
  }
`;
